<script>
export default {
  props: ["value"],
  data() {
    return {
      id: this.value.id,
      cardBrand: this.value.card,
      cardDigitMode: this.value.card_digit,
      cutCardNumber: '',
      options: [
        { value: null, text: "Please select" },
        { value: "amex", text: "AMEX" },
        { value: "visa", text: "VISA" },
        { value: "mastercard", text: "MasterCard" }
      ],
      cardDigit: [
        { value: null, text: "Please select" },
        { value: "first_6", text: "First 6 digit" },
        { value: "last_4", text: "Last 4 digit" }
      ],
      cardDigitPlaceHolder: '',
      cardDigitErrorMsg: '',
      cardMaxLength: 4
    };
  },
  computed: {
    cardInputState() {
      if (this.cardDigitMode == 'first_6') {
        if (!this.validateStringLength(this.cutCardNumber, 6)) return false;
      } else if (this.cardDigitMode == 'last_4') {
        if (!this.validateStringLength(this.cutCardNumber, 4) || this.cutCardNumber.length > 4) return false;
      }
      if (!this.validateStringRegex(this.cutCardNumber, /\d/)) return false;
      return true;
    },
    cardBrandState() {
      if (!this.cardBrand) return false;
      return true;
    },
    cardDigitState() {
      if (!this.cardDigitMode) return false;
      return true;
    },
    isValid() {
      return this.cardInputState && this.cardBrandState && this.cardDigitState;
    },
    cardDigitValue() {
      return `card_digit_value_${this.id}`;
    },
    selectCardDigit() {
      return `card_digit_select_${this.id}`;
    }
  },
  watch: {
    isValid(val) {
      this.$emit("isValid", {
        id: this.id,
        isValid: val
      });
    }
  },
  methods: {
    handleChange(sample) {
      setTimeout(() => {
        let card_digit = document.getElementById(`${this.cardDigitValue}`)
        let card_select = document.getElementById(`${this.selectCardDigit}`)
        if (card_select.value) {
          if (card_select.value == "first_6") {
            this.cardMaxLength = 6
            this.cardDigitPlaceHolder = "Enter first 6 digit"
            this.cardDigitErrorMsg = "Enter first 6 digits"
          }else if (card_select.value == "last_4") {
            this.cardMaxLength = 4
            this.cardDigitPlaceHolder = "Enter last 4 digit"
            this.cardDigitErrorMsg = "Enter last 4 digits"
          }
      
        }

        this.$emit("input", {
          id: this.id,
          card_brand: this.cardBrand,
          first_six_digits: this.cutCardNumber.length == 6 ? this.cutCardNumber :'',
          last_four_digits: this.cutCardNumber.length == 4 ? this.cutCardNumber :'',
          card_digit: this.cardDigitMode
        });
      }, 500);
      
    },
    handleRemove() {
      this.$emit("removed", {
        id: this.id
      });
    },
    validateStringLength(str, length) {
      if (str.length < length) return false;
      return true;
    },
    validateStringRegex(str, pattern) {
      for (let index = 0; index < str.length; index++) {
        if (!pattern.test(str[index])) {
          return false;
        }
      }
      return true;
    }
  }
};
</script>

<template>
  <b-tr>
    <b-td>
      <b-form-group id="input-group-card-brand" label-for="select-card-branda">
        <b-form-select
          id="select-card-branda"
          v-model="cardBrand"
          :options="options"
          @change="handleChange"
          :state="cardBrandState"
          required
        ></b-form-select>
        <b-form-invalid-feedback id="input-live-feedback">
          Select your card
        </b-form-invalid-feedback>
      </b-form-group>
    </b-td>

    <b-td>
      <b-form-group id="input-group-card-digit" :label-for="selectCardDigit">
        <b-form-select
          :id="selectCardDigit"
          v-model="cardDigitMode"
          :options="cardDigit"
          @change="handleChange"
          :state="cardDigitState"
          required
        ></b-form-select>
        <b-form-invalid-feedback id="input-live-feedback">
          Enter your card details
        </b-form-invalid-feedback>
      </b-form-group>
    </b-td>

    <b-td>
      <b-form-group v-if="this.cardDigitMode"
        id="input-group-first-six-digits"
        :label-for="cardDigitValue"
      >
        <b-form-input
          :id="cardDigitValue"
          v-model="cutCardNumber"
          type="text"
          :maxlength="cardMaxLength"
          :placeholder="cardDigitPlaceHolder"
          required
          :state="cardInputState"
          @change="handleChange"
        ></b-form-input>
        <b-form-invalid-feedback id="input-live-feedback">
          {{cardDigitErrorMsg}}
        </b-form-invalid-feedback>
      </b-form-group>
      <!-- <b-form-group
        id="input-group-last-four-digits"
        label-for="input-last-four-digits"
        @change="handleChange"
      >
        <b-form-input
          id="input-last-four-digits"
          placeholder="Enter Last 4 Digits"
          v-model="lastFourDigits"
          type="text"
          maxlength="4"
          required
          :state="last4State"
          @change="handleChange"
        ></b-form-input>
        <b-form-invalid-feedback id="input-live-feedback">
          Enter exactly 4 digits
        </b-form-invalid-feedback>
      </b-form-group> -->
    </b-td>

    <b-td sm="2">
      <b-button variant="danger" size="sm" @click="handleRemove"
        >Remove</b-button
      >
    </b-td>
  </b-tr>
</template>
